import React, { useState } from 'react';
import { Navbar, Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import NavBellIcon from '../assets/img/nav-bell.png';
import NavSettingIcon from '../assets/img/nav-setting.png';
import Image from 'react-bootstrap/Image';
import '../assets/style/ToolBar.css';
import { loginSelector } from '../features/loginSlice';
import { LoggedUserType, UserType } from '../utils/Types';
import { SIDE_MENU_STATUS } from '../utils/Constant';
import MenuIcon from '../assets/img/menu.svg';
import { updateSideMenuStatus } from '../features/dashboardSlice';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import NotificationPage from '../pages/Notifications/NotificationsPage';
import { Avatar } from '@mui/material';
import { getPhotoSrc } from '../utils/Util';
import EmployeeInformationModal from '../pages/modals/EmployeeInformationModal';

const ToolBar = () => {
  const dispatch = useAppDispatch();
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;

  const updateSideMenu = () => {
    dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.OPPOSITE));
  };
  const [showNotifications, setShowNotifications] = useState(false);
  const [showEmployeeDetails, setShowEmployeeDetails] = useState(false);
  return (
    <>
      <Navbar
        color="light"
        className="navbar mt-1 bg-white rounded pl-0 position-relative"
        expand="md"
      >
        <div className="d-flex flex-row">
          <Image
            src={MenuIcon}
            className="menu"
            onClick={() => {
              updateSideMenu();
            }}
          />
          <div className="toolBar-welcome">Welcome,</div>
          <div className="px-2 toolBar-name">
            {`${
              user?.firstname ? user?.firstname : ''
            } ${user?.lastName ? user?.lastName : ''}`}
          </div>
        </div>
        <div className="nav-menu">
          <Nav className="ml-auto">
            <NavItem className="toolBar-NavItem-item">
              <NavLink
                className="toolBar-NavLink-item"
                onClick={() => {
                  setShowEmployeeDetails(true);
                }}
              >
                <Avatar alt="profilepic" src={getPhotoSrc(userDetails.photo)} />
              </NavLink>
            </NavItem>
            <NavItem className="toolBar-NavItem-item">
              <NavLink
                className="toolBar-NavLink-item"
                onClick={() => {
                  setShowNotifications(true);
                }}
              >
                <Image src={NavBellIcon} alt="icon" className="toolBar-icon" />
              </NavLink>
            </NavItem>
            <NavItem className="toolBar-NavItem-item">
              <NavLink
                className="toolBar-NavLink-item"
                tag={Link}
                to={'setting'}
              >
                <Image
                  src={NavSettingIcon}
                  alt="icon"
                  className="toolBar-icon"
                />
              </NavLink>
            </NavItem>
          </Nav>
        </div>
        <DropdownButton
          id="dropdown-basic-button"
          className="drop-menu drop-menu-bg"
          title=""
        >
          <Dropdown.Item
            onClick={() => {
              setShowEmployeeDetails(true);
            }}
          >
            Profile
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              setShowNotifications(true);
            }}
          >
            Notifications
          </Dropdown.Item>
          <Dropdown.Item href="#/setting">Setting</Dropdown.Item>
        </DropdownButton>
      </Navbar>
      {showNotifications && (
        <NotificationPage
          open={showNotifications}
          toggle={setShowNotifications}
        />
      )}
      {showEmployeeDetails && (
        <EmployeeInformationModal
          isOpen={showEmployeeDetails}
          toggleModal={() => {
            setShowEmployeeDetails(false);
          }}
          candidateId={user.candidateId}
          readOnly
        />
      )}
    </>
  );
};

export default ToolBar;
